import { render, staticRenderFns } from "./AnswerCreateEditModal.vue?vue&type=template&id=1a0761a6&"
import script from "./AnswerCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./AnswerCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports